interface AnalyticsTagProps {
  analyticsTag: string;
}

interface GeenrateMenuAriaControlIdProps extends AnalyticsTagProps {
  idPrefix?: string;
}

export const generateMenuAriaControlId = ({
  analyticsTag,
  idPrefix = "sub-menu",
}: GeenrateMenuAriaControlIdProps) => {
  return `${idPrefix}-${analyticsTag
    .replace(/[^A-Za-z]/g, "")
    .toLocaleLowerCase()}`;
};

interface ElementBaseProps extends Partial<AnalyticsTagProps> {
  containerLinkText?: string;
}

interface GenerateMenuAriaHtmlProps {
  htmlProperty: "id" | "aria-controls";
}

const generateMenuAriaHtmlProps =
  ({ htmlProperty }: GenerateMenuAriaHtmlProps) =>
  ({ analyticsTag, containerLinkText }: ElementBaseProps) => {
    if (!analyticsTag) return {};

    return {
      [htmlProperty]: generateMenuAriaControlId({
        analyticsTag,
        idPrefix: containerLinkText
          ? generateMenuAriaControlId({
              analyticsTag: containerLinkText,
            })
          : undefined,
      }),
    };
  };

interface GenerateMenuAriaControlsProps extends ElementBaseProps {
  targetElementShown: boolean;
}

/**
 * Adds aria-controls attribute to the clicking element if the target element is already showing
 */
export const generateMenuAriaControlsProps = ({
  targetElementShown,
  ...elementBaseProps
}: GenerateMenuAriaControlsProps) => {
  return targetElementShown
    ? generateMenuAriaHtmlProps({
        htmlProperty: "aria-controls",
      })(elementBaseProps)
    : {};
};

export const generateSubMenuIdProps = generateMenuAriaHtmlProps({
  htmlProperty: "id",
});
